export const CAROUSEL_CARD_WIDTH = 108;
export const CAROUSEL_PERSPECTIVE = 1200;

export function wrapCarouselIndex(value: number, count: number): number {
  'worklet';
  return count > 0 ? ((value % count) + count) % count : 0;
}

function orbitAngle(index: number, progress: number, count: number): number {
  'worklet';
  return count > 1 ? ((index - wrapCarouselIndex(progress, count)) * Math.PI * 2) / count : 0;
}

/** All visual depth cues and stacking use the same point on the orbit. */
export function carouselPose(index: number, progress: number, count: number, spread: number) {
  'worklet';
  const angle = orbitAngle(index, progress, count);
  const depth = (Math.cos(angle) + 1) / 2;
  let layer = 1;

  // Rank every pair, including the two rear cards. A single "front index"
  // cannot describe their occlusion while they cross behind the front card.
  for (let other = 0; other < count; other += 1) {
    if (other === index) continue;
    const otherDepth = (Math.cos(orbitAngle(other, progress, count)) + 1) / 2;
    const difference = depth - otherDepth;
    if (difference > 1e-9 || (Math.abs(difference) <= 1e-9 && index > other)) layer += 1;
  }

  return {
    depth,
    layer,
    translateX: Math.sin(angle) * spread,
    translateY: (1 - depth) * 16,
    rotateY: -Math.sin(angle) * 16,
    scale: 0.86 + depth * 0.14,
  };
}
